<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Cadastrar Bancos</span>
    <span class="spacer"></span>
    <button
      mat-raised-button
      color="primary"
      data-cy="newBank"
      (click)="openBank()"
    >
      Novo
    </button>
  </mat-toolbar-row>
</mat-toolbar>
  
<mat-accordion>
  <mat-card>
    <mat-card-header> </mat-card-header>
    <mat-card-content>
      <form #thisForm="ngForm">
        <div class="filters">
          <div class="row">
            <div class="col-4">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  placeholder="Código"
                  [(ngModel)]="code"
                  name="Código"
                />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  placeholder="Nome Extenso"
                  [(ngModel)]="name"
                  name="name"
                />
              </mat-form-field>
            </div>
            <div class="col-2">
              <button
                mat-raised-button
                color="primary"
                class="filter-button"
                type="submit"
                (click)="clearFilters()"
              >
                Limpar
              </button>
            </div>
            <div class="col-2">
              <button
                mat-raised-button
                color="primary"
                class="filter-button"
                type="submit"
                (click)="getBanksList()"
              >
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</mat-accordion>

<table mat-table [dataSource]="banksList" class="banks">
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let banks" class="actions">
      <fa-icon
        id="user-{{ banks.id }}-id"
        [icon]="faListAlt"
        (click)="openBank(banks.id)"
      ></fa-icon>
    </td>
  </ng-container>
  
  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef>Código</th>
    <td mat-cell *matCellDef="let banks">{{ banks.code }}</td>
  </ng-container>
  <ng-container matColumnDef="shortName">
    <th mat-header-cell *matHeaderCellDef>Nome Abreviado</th>
    <td mat-cell *matCellDef="let banks">{{ banks.shortName }}</td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Nome Extenso</th>
    <td mat-cell *matCellDef="let banks">{{ banks.name }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<paginador
  [listedPages]="listedPages"
  [firstItemOnPage]="firstItemOnPage"
  [lastItemOnPage]="lastItemOnPage"
  [totalPages]="totalPages"
  [totalItems]="totalItems"
  [itemsPerPage]="[10, 25, 50, 100]"
  [currentPage]="currentPage"
  (onSearch)="getBanksList($event[0], $event[1])"
></paginador>
  